

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
// Material Dashboard 2 React UIComponents
import DataTable from "UIComponents/Tables/DataTable";

// Data
import data from "layouts/dashboard/components/DevicesOverview/data";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";


function DevicesOverview() {
  const { columns, rows } = data();
  const {t}=useTranslation()
  return (
    <MDCard>
     <MDTypography fontWeight='bold' ml={1.5} mt={1}>{t('headings.devices')}</MDTypography>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
       
          entriesPerPage={false}
        
        />
      </MDBox>
    </MDCard>
  );
}

export default DevicesOverview;
